import React from 'react';

interface PageWrapperProps {
  children: React.ReactNode;
  className?: string;
  $fullWidth?: boolean;
  $background?: string;
  $padding?: string;
  props?: React.HTMLAttributes<HTMLDivElement>;
}

const PageWrapper = ({
  children,
  className = '',
  $fullWidth,
  $background,
  $padding,
  props,
}: Readonly<PageWrapperProps>) => {
  const hasPadding = Boolean($padding);
  const hasBackground = Boolean($background);
  const styleProp = {
    ...props?.style,
    ...(hasBackground ? { backgroundColor: $background } : {}),
    ...(hasPadding ? { padding: $padding } : {}),
  };

  const paddingClass = hasPadding ? '' : 'p-6';

  return (
    <div
      className={`${!hasBackground && 'bg-background'} ${$fullWidth ? 'w-full' : 'max-w-screen-xl'} ${paddingClass} my-0 mx-auto ${className}`}
      style={Object.keys(styleProp).length > 0 ? styleProp : undefined}
      {...props}
    >
      {children}
    </div>
  );
};

export default PageWrapper;
